import { render } from "./MenuTableCellText.vue?vue&type=template&id=579d2f03"
import script from "./MenuTableCellText.vue?vue&type=script&lang=js"
export * from "./MenuTableCellText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__